export const BACKEND_API_URL = process.env.GATSBY_BACKEND_API_URL;
